<template>
  <el-dialog
    :title="auditInfo.title"
    :visible.sync="auditInfo.showDia"
    v-if="auditInfo.showDia"
    :close-on-click-modal="false"
  >
    <el-form
      :model="ruleForm"
      ref="rForm"
      label-width="100px"
      class="ruleForm"
      :rules="rules"
    >
      <el-form-item label="审核进度：" prop="auditSchedule">
        <el-radio-group
          v-model="ruleForm.auditSchedule"
          @change="auditScheduleChange"
        >
          <el-radio
            v-for="(item, i) in auditScheduleAttr"
            :key="i"
            :label="item.paramKey"
          >
            {{ item.paramValue }}</el-radio
          >
        </el-radio-group>
      </el-form-item>
      <el-form-item label="审核人：" prop="auditUserId" v-if="showMan">
        <el-cascader
          v-model="ruleForm.auditUserId"
          :options="memberList"
          :props="{ value: 'id', label: 'name' }"
          @change="handleChange"
          placeholder="请选择审核人"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="审核意见：" prop="auditContent">
        <el-input
          type="textarea"
          placeholder="请输入审核意见"
          :row="3"
          v-model="ruleForm.auditContent"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeFrom()" btntype title="取消"></butn>
      <butn btntype="primary" @click.native="updateForm()" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import { auditUpdate } from "@/api/user";
import { getDataMap } from "@/api/sysParam";
import { userAuditorList } from "@/api/user";

export default {
  components: { butn },
  props: ["auditInfo"],
  data() {
    return {
      size: "small",
      ruleForm: {},
      showMan: false,
      auditScheduleAttr: [],
      memberList: [],
      rules: {
        auditSchedule: [{ required: true, message: "请选择审核进度" }],
        auditUserId: [{ required: true, message: "请选择审核人" }],
        auditContent: [
          { required: false, message: "请选择审核意见", trigger: "bulr" },
        ],
      },
    };
  },
  methods: {
    handleChange() {},
    auditScheduleChange(val) {
      this.showMan = val == 3;
    },
    closeFrom() {
      this.$emit("closeDia", 0, 0);
    },
    updateForm() {
      this.$refs["rForm"].validate((valid) => {
        if (valid) {
          let params = {
            uuid: this.auditInfo.uuids,
            auditSchedule: this.ruleForm.auditSchedule,
            auditContent: this.ruleForm.auditContent,
          };
          if (!this.auditInfo.isBatch) {
            let auditUserId = "";
            if (this.ruleForm.auditUserId) {
              auditUserId = this.ruleForm.auditUserId[
                this.ruleForm.auditUserId.length - 1
              ];
            }
            params["auditUserId"] = auditUserId;
          }
          auditUpdate(params).then((res) => {
            if (res.code === 0) {
              this.$message.success(res.msg);
              this.$emit("closeDia", 0, 1);
            }
          });
        }
      });
    },
  },
  created() {
    getDataMap("AUDIT_SCHEDULE").then((res) => {
      if (!res || res.code != 0) return;
      if (this.auditInfo.isBatch) {
        this.auditScheduleAttr = res.data.slice(1, 3);
      } else {
        this.auditScheduleAttr = res.data.slice(1, 4);
      }
    });
    if (!this.auditInfo.isBatch) {
      userAuditorList(this.auditInfo.deptId).then(({ code, data }) => {
        if (code === 0) {
          this.memberList = data;
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.button-dept {
  margin-left: 10px;
}
</style>
